import Vue from 'vue'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'


import {Tooltip,MessageBox,Tag, PageHeader, Row, Col,Switch, Menu, Submenu, MenuItem, Select, Option, Button, ButtonGroup, Form, FormItem, Input, Checkbox, Dropdown, DropdownMenu, DropdownItem, Tabs, TabPane, Table, Loading, TableColumn, Pagination, Drawer, Breadcrumb, BreadcrumbItem, Dialog, Upload, Message, DatePicker, InputNumber, Image, Popover, Notification,Cascader } from 'element-ui'

Vue.prototype.Message = Message;
Vue.prototype.$messageBox = MessageBox;
Vue.prototype.Notify = Vue.prototype.$notify = Notification;
var elementuis = [
    Tooltip,
    Tag,
    PageHeader,
    Row,
    Col,
    Switch,
    Menu,
    Submenu,
    MenuItem,
    Select,
    Option,
    Button,
    ButtonGroup,
    Form,
    FormItem,
    Input,
    InputNumber,
    Checkbox,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Tabs,
    TabPane,
    Table,
    Loading,
    TableColumn,
    Pagination,
    Drawer,
    Breadcrumb,
    BreadcrumbItem,
    Dialog,
    Upload,
    /*Message,*/
    DatePicker,
    Image,
    Popover,
    Cascader,
]
Vue.use(VueI18n)

elementuis.forEach(element => {
    Vue.use(element)
});

locale.use(zhLocale)

Vue.prototype.$setLang = (lang) => {
  if (lang === 'en') {
    locale.use(enLocale)
  } else {
    locale.use(zhLocale)
  }
}

